export { default } from "./paymenet.svelte";
